import StateTransition from '@/ecm/models/workflow/StateTransition';
export default class State {
    constructor (dto) {
        this.id = 0;
        this.description = '';
        this.numberOfDaysNotif = 0;
        this.notifyOnExpiration = false;
        this.notifyOnStateChange = false;
        this.transitions = [];

        if (dto) {
            this.id = dto.Id;
            this.description = dto.Description;
            this.numberOfDaysNotif = dto.NumberOfDaysNotif;
            this.notifyOnStateChange = dto.NotifyOnStateChange;
            this.notifyOnExpiration = dto.NotifyOnExpiration;
            this.transitions = dto.Transitions.map(function (dto) { return new StateTransition(dto); });
        }
    }

    toDto () {
        return {
            Id: this.id,
            Description: this.description,
            NumberOfDaysNotif: this.numberOfDaysNotif,
            NotifyOnExpiration: this.notifyOnExpiration,
            NotifyOnStateChange: this.notifyOnStateChange,
            Transitions: this.transitions.map(x => x.toDto()),
        };
    }
}
